import React, { useState } from "react";
import { AuthProvider, useAuth } from "./AuthContext";
import LoginPage from "./LoginPage";
import DownloadPage from "./DownloadPage";
import UploadPage from "./UploadPage";
import UsersPage from "./UsersPage";
import ScanInvoice from "./ScanInvoice";
import BackfillPage from "./BackfillPage";
import ZaradePage from "./ZaradePage";
import { FaSignOutAlt, FaUser } from "react-icons/fa";

function AppContent() {
  const { user, logout, isAdmin, tokenExpiringSoon } = useAuth();
  const [activePage, setActivePage] = useState(isAdmin ? "users" : "upload");

  if (!user) {
    return <LoginPage />;
  }

  const pages = [
    { name: "upload", label: "Slanje faktura" },
    { name: "download", label: "Preuzimanje" },
    ...(isAdmin
      ? [
          { name: "users", label: "Korisnici" },
          { name: "scanInvoice", label: "Skeniranje" },
          { name: "backfill", label: "Dopuna" },
          { name: "zarade", label: "Knjiženje zarada" },
        ]
      : []),
  ];

  return (
    <div className="app-wrapper">
      <header className="app-header">
        <h1 className="header-title">INFOTRADE</h1>
        <div className="header-user">
          <FaUser style={{ marginRight: 6 }} />
          <span className="header-username">{user.companyName || user.username}</span>
          {isAdmin && <span className="header-role">Admin</span>}
          <button className="btn-logout" onClick={logout}>
            <FaSignOutAlt style={{ marginRight: 4 }} /> Odjavi se
          </button>
        </div>
      </header>
      {tokenExpiringSoon && (
        <div style={{
          background: "var(--warning-bg)",
          color: "var(--warning)",
          padding: "10px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 12,
          fontSize: 14,
          fontWeight: 500,
        }}>
          <span>Vasa sesija uskoro istice. Prijavite se ponovo.</span>
          <button
            onClick={logout}
            style={{
              background: "var(--warning)",
              color: "white",
              border: "none",
              padding: "6px 14px",
              borderRadius: 6,
              cursor: "pointer",
              fontSize: 13,
              fontWeight: 600,
            }}
          >
            Ponovo se prijavi
          </button>
        </div>
      )}
      <nav className="app-nav">
        {pages.map((page) => (
          <button
            key={page.name}
            className={`nav-tab ${activePage === page.name ? "active" : ""}`}
            onClick={() => setActivePage(page.name)}
          >
            {page.label}
          </button>
        ))}
      </nav>
      <main className="app-main">
        {activePage === "upload" && <UploadPage />}
        {activePage === "download" && <DownloadPage />}
        {activePage === "users" && isAdmin && <UsersPage />}
        {activePage === "scanInvoice" && isAdmin && <ScanInvoice />}
        {activePage === "backfill" && isAdmin && <BackfillPage />}
        {activePage === "zarade" && isAdmin && <ZaradePage />}
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
